__turbopack_context__.v({
  "bg": "Hero-module__EuRKEq__bg",
  "desktopBanner": "Hero-module__EuRKEq__desktopBanner",
  "img": "Hero-module__EuRKEq__img",
  "mobileBanner": "Hero-module__EuRKEq__mobileBanner",
  "slideshow-bg": "Hero-module__EuRKEq__slideshow-bg",
  "slideshow-bg__img": "Hero-module__EuRKEq__slideshow-bg__img",
  "swiper": "Hero-module__EuRKEq__swiper",
  "wrapper": "Hero-module__EuRKEq__wrapper",
});
